import Vue from 'vue'
import './config/rem'
import App from './App.vue'
import router from './router'
Vue.config.productionTip = false

import VueAxios from 'vue-axios'
import VueRouter from 'vue-router'

import axios from 'axios'
Vue.prototype.$axios = axios
axios.defaults.baseURL = '/api'

//工具类
import Util from './config/util'
Vue.use(Util);

//提前截取url参数信息
import {ImgArr} from './config/resource'
Vue.prototype.$ImgArr = new ImgArr();

//提前截取url参数信息
import {UrlSearch} from './config/urlConfig'
Vue.prototype.$Request = new UrlSearch();

//自定义统计
import TrackV2 from './config/track_V2'
Vue.use(TrackV2);


Vue.use(VueAxios, axios, VueRouter)
import VueI18n from 'vue-i18n'

Vue.use(VueI18n) // 通过插件的形式挂载
const i18n = new VueI18n({
    locale: navigator.language.toLowerCase(),
    fallbackLocale: 'en',
    silentFallbackWarn: true,
    messages: {
        'de': require('./config/json/de'),
        'en': require('./config/json/en'),
        'es': require('./config/json/es'),
        'fr': require('./config/json/fr'),
        'id': require('./config/json/id'),
        'ja': require('./config/json/ja'),
        'ms': require('./config/json/ms'),
        'pt': require('./config/json/pt'),
        'th': require('./config/json/th'),
        'ru': require('./config/json/ru'),
        'vi': require('./config/json/vi'),
        'ko': require('./config/json/ko')
    }
})

new Vue({
    i18n,
    router,
    render: h => h(App),
}).$mount('#app')
